import { config } from '../apiConfig';

const OfficialInvoice = async (parameters) => {
  //  document.location.href = `${config.url}/api/mvc/voucher/officialInvoice/${parameters.reserveId}`;
    let AccessToken = localStorage.getItem('AccessToken');
    let url = `${config.url}/api/mvc/voucher/officialInvoice/${parameters.reserveId}`;

    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${AccessToken}`,
            },
        });

        if (!response.ok) {
            throw new Error('Failed to fetch the file');
        }

        const blob = await response.blob();
        // Create a blob URL
        const urlDownload = window.URL.createObjectURL(blob);

        // Create an anchor element for download
        const a = document.createElement('a');
        a.href = urlDownload;
        a.download = 'wallet-report.pdf'; // Specify the desired file name
        document.body.appendChild(a); // Append the anchor to the DOM
        a.click(); // Trigger the click event
        document.body.removeChild(a); // Clean up the anchor element

        // Revoke the blob URL to free memory
        window.URL.revokeObjectURL(urlDownload);

    } catch (error) {
        console.error('Error while downloading the file:', error);
    }
}

export default OfficialInvoice;